var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-card-actions', {
    attrs: {
      "title": "KPI Commission",
      "amount": _vm.kpiCommissionAmount,
      "currency": _vm.currency,
      "collapsed": true,
      "action-collapse": ""
    }
  }, [_c('b-form', [_c('b-row', [_c('b-col', {
    class: {
      'disabled': _vm.payslip && _vm.payslip.status === 'finally_generated'
    },
    attrs: {
      "cols": "4"
    }
  }, [_c('h5', {
    staticClass: "text-capitalize"
  }, [_vm._v(" KPI Commission Amount Input ")]), [_c('div', [_c('ValidationProvider', {
    attrs: {
      "name": "Commission amount",
      "vid": "commission_amount",
      "rules": "required|min:0"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var _vm$payslip;
        var errors = _ref.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "kpi_commission_amount",
            "state": errors.length > 0 ? false : null,
            "type": "number",
            "disabled": ((_vm$payslip = _vm.payslip) === null || _vm$payslip === void 0 ? void 0 : _vm$payslip.status) === 'finally_generated',
            "placeholder": "Kpi Commission Amount"
          },
          model: {
            value: _vm.kpiCommissionAmount,
            callback: function callback($$v) {
              _vm.kpiCommissionAmount = $$v;
            },
            expression: "kpiCommissionAmount"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)]], 2), _c('b-col', {
    attrs: {
      "offset": "5",
      "cols": "3"
    }
  }, [_c('h5', {
    staticClass: "text-capitalize"
  }, [_vm._v(" KPI Commission Amount ")]), [_c('div', [_c('b-form-input', {
    attrs: {
      "id": "kpi_commission_amount",
      "type": "number",
      "placeholder": "Kpi Commission Amount",
      "disabled": true
    },
    model: {
      value: _vm.kpiCommissionAmount,
      callback: function callback($$v) {
        _vm.kpiCommissionAmount = $$v;
      },
      expression: "kpiCommissionAmount"
    }
  })], 1)]], 2)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }